// extracted by mini-css-extract-plugin
module.exports = {"actions":"styles_actions__WJ-Jh","col":"styles_col__2r9iN"};